export default __webpack_public_path__ + "static/media/Belt of the Primal Spirit.a0a309aa.jpg";